import React from 'react'
import ComputerConfirmedAppointment from './ComputerConfirmedAppointment'

export default function ComputerAppointmentPage ({ box, appointment, onCancel, appointmentStatus }) {
  return (
    <ComputerConfirmedAppointment box={box} appointment={appointment} onCancel={onCancel} appointmentStatus={appointmentStatus} />
  )
}
